module.exports = __webpack_public_path__ + "ico-crypto-usdt.svg?15d1570aee2d56cc6adf052fcd80bcd0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/ico-crypto-usdt.svg
// module id = 136
// module chunks = 2